import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AnalyticsCoreModule } from '../../analytics-core/analytics-core.module';
import { SharedModule } from '../../shared/shared.module';
import { AccountDropdownV6Component } from './components/account-dropdown-v6/account-dropdown-v6.component';
import { BreadcrumbAnchorComponent } from './components/breadcrumb-anchor/breadcrumb-anchor.component';
import { BreadcrumbItemComponent } from './components/breadcrumb-item/breadcrumb-item.component';
import { BreadcrumbNavigatorComponent } from './components/breadcrumb-navigator/breadcrumb-navigator.component';
import { BreadcrumbSettingsComponent } from './components/breadcrumb-settings/breadcrumb-settings.component';
import { BreadcrumbToggleComponent } from './components/breadcrumb-toggle/breadcrumb-toggle.component';
import { BreadcrumbComponent } from './components/breadcrumb.component';
import { MyToolTipDirective } from './components/tooltip.component';

@NgModule({
	bootstrap: [BreadcrumbComponent],
	declarations: [
		BreadcrumbComponent,
		BreadcrumbItemComponent,
		BreadcrumbAnchorComponent,
		MyToolTipDirective,
		BreadcrumbToggleComponent,
		BreadcrumbNavigatorComponent,
		BreadcrumbSettingsComponent,
		AccountDropdownV6Component
	],
	exports: [
		BreadcrumbComponent,
		BreadcrumbItemComponent,
		BreadcrumbAnchorComponent,
		BreadcrumbSettingsComponent,
		AccountDropdownV6Component
	],
	imports: [AnalyticsCoreModule, SharedModule, CommonModule]
})
export class BreadcrumbModule {}
